import React, { useEffect } from 'react';
import { ArrowRight, Check, Instagram, Play } from 'lucide-react';
import FloatingChatButton from '../components/FloatingChatButton';
import farzeenImage from '../assets/farzeen-funnel.png';

const FunnelPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Testimonials data - editable
  const testimonials = [
    {
      name: "Sarah Turner",
      timeAgo: "2d ago",
      title: "Made my first 2,200 in two days!",
      text: "Oh my goodness it feels amazing! Like it totally makes me believe that I can do it!! Welcome success story that totally is like oh my God one day at a time and keep going!",
      engagement: { likes: 8, comments: 2 }
    },
    {
      name: "Savanah Sutcliffe", 
      timeAgo: "10d ago",
      title: "A HUGE milestone!! I hit 10K",
      text: "I started in July of this year, and I just hit five-figures in my business last night. I'm not exaggerating when I say digital marketing has changed my life completely!!!",
      engagement: { likes: 30, comments: 23 }
    },
    {
      name: "Aiman Zohra",
      timeAgo: "4d ago", 
      title: "First 2 High Ticket sales in 41 days of Launching",
      text: "I begin with my DWA journey on 20th of September 2024 as a total beginner in digital marketing, I just joined it and had an idea that I can earn through this and create a thriving business.",
      engagement: { likes: 6, comments: 1 }
    }
  ];

  // What you'll learn points - editable
  const learnPoints = [
    "The exact 90% done-for-you system that's generating $10K+ months",
    "How to start with ZERO tech skills or experience",
    "Why you don't need to show your face or create products",
    "The simple strategy that works even with a small following",
    "How to build this around your family's schedule"
  ];

  // 3 Key Steps - editable
  const keySteps = [
    {
      number: "01",
      title: "The Ultimate Product Hack",
      subtitle: "Affiliate Marketing",
      description: "Skip months of product creation. Get done-for-you digital products with full resell rights. Start selling immediately and keep up to 85% commission on every sale."
    },
    {
      number: "02", 
      title: "Your Digital Storefront",
      subtitle: "Instagram Strategy",
      description: "Turn your Instagram into a 24/7 sales machine. Learn the exact content strategy that attracts buyers and converts followers into customers organically."
    },
    {
      number: "03",
      title: "The Mentorship Step",
      subtitle: "Proven Guidance",
      description: "Get direct support from someone who's already achieved the results you want. No more guessing or trial and error - follow a proven roadmap to success."
    }
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#f8f6f3' }}>
      {/* Navigation */}
      <nav className="py-5 px-8" style={{ backgroundColor: '#1a1a1a' }}>
        <div className="container mx-auto flex items-center justify-between">
          <a 
            href="/" 
            className="text-sm tracking-[0.3em] font-light hover:opacity-70 transition-opacity italic"
            style={{ color: '#ffffff', fontFamily: "'Playfair Display', serif" }}
          >
            Farzeen
          </a>
          <a 
            href="https://instagram.com/itsfarzeenkhan" 
            target="_blank" 
            rel="noopener noreferrer"
            className="transition-opacity hover:opacity-60"
            style={{ color: '#ffffff' }}
          >
            <Instagram size={18} strokeWidth={1.5} />
          </a>
        </div>
      </nav>

      {/* Hero Section with Video */}
      <section className="py-12 md:py-16" style={{ backgroundColor: '#1a1a1a' }}>
        <div className="container mx-auto px-6 md:px-8">
          <div className="max-w-4xl mx-auto text-center">
            {/* Pre-headline */}
            <p 
              className="text-xs tracking-[0.4em] mb-4 font-light uppercase"
              style={{ color: '#8b7355' }}
              data-testid="funnel-pre-headline"
            >
              Free Training
            </p>
            
            {/* Main Headline - EDITABLE */}
            <h1 
              className="text-2xl md:text-3xl lg:text-4xl font-light leading-tight mb-4"
              style={{ fontFamily: "'Playfair Display', serif", color: '#ffffff' }}
              data-testid="funnel-headline"
            >
              How I've Made $10K+ Monthly
              <br />
              <span className="italic" style={{ color: '#8b7355' }}>with this NEW way of digital marketing...</span>
            </h1>
            
            {/* Sub-headline - EDITABLE */}
            <p 
              className="text-base md:text-lg font-light mb-8 max-w-2xl mx-auto"
              style={{ color: 'rgba(255,255,255,0.7)' }}
              data-testid="funnel-subheadline"
            >
              Without creating my own products OR building any complicated websites.
            </p>
          </div>

          {/* VIDEO SECTION - YouTube Embed Goes Here */}
          <div className="max-w-3xl mx-auto">
            <div 
              className="aspect-video rounded-lg shadow-2xl overflow-hidden"
              style={{ backgroundColor: '#0a0a0a', border: '1px solid rgba(139, 115, 85, 0.3)' }}
              data-testid="video-container"
            >
              {/* 
                ========================================
                YOUTUBE VIDEO EMBED - REPLACE THIS DIV
                ========================================
                
                To add your YouTube video, replace this entire placeholder div with:
                
                <iframe 
                  className="w-full h-full"
                  src="https://www.youtube.com/embed/YOUR_VIDEO_ID"
                  title="Free Training Video"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
                
                Example: If your YouTube URL is https://www.youtube.com/watch?v=abc123
                Use: src="https://www.youtube.com/embed/abc123"
              */}
              <div className="w-full h-full flex items-center justify-center">
                <div className="text-center p-8">
                  <div 
                    className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4 cursor-pointer transition-all hover:scale-105"
                    style={{ backgroundColor: 'rgba(139, 115, 85, 0.2)', border: '2px solid #8b7355' }}
                  >
                    <Play size={32} fill="#8b7355" style={{ color: '#8b7355', marginLeft: '4px' }} />
                  </div>
                  <p className="text-sm font-light" style={{ color: 'rgba(255,255,255,0.6)' }}>
                    Your video will appear here
                  </p>
                  <p className="text-xs mt-2 font-light" style={{ color: 'rgba(255,255,255,0.3)' }}>
                    Provide your YouTube link to embed
                  </p>
                </div>
              </div>
            </div>
            
            <p className="text-center text-sm font-light mt-6" style={{ color: 'rgba(255,255,255,0.5)' }}>
              Watch the full training above to discover exactly how this works
            </p>
          </div>
        </div>
      </section>

      {/* Social Proof - Intro Text */}
      <section className="py-12 md:py-16" style={{ backgroundColor: '#f8f6f3' }}>
        <div className="container mx-auto px-6 md:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <p 
              className="text-base md:text-lg font-light leading-relaxed mb-4"
              style={{ color: '#1a1a1a' }}
            >
              In the next few minutes, I'm going to share with you <span className="font-medium">EXACTLY</span> how I've achieved 
              financial freedom with the power of this one skill — <span className="italic" style={{ color: '#8b7355' }}>digital marketing</span>.
            </p>
            <p className="text-sm font-light" style={{ color: '#666' }}>
              And it's not just me, some top students are also winning, like:
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-12 md:py-16" style={{ backgroundColor: '#ffffff' }}>
        <div className="container mx-auto px-6 md:px-8">
          <div className="max-w-5xl mx-auto">
            <p 
              className="text-xs tracking-[0.3em] mb-8 font-light text-center uppercase"
              style={{ color: '#8b7355' }}
            >
              Real Results From Real People
            </p>
            
            <div className="grid md:grid-cols-3 gap-6">
              {testimonials.map((testimonial, index) => (
                <div 
                  key={index}
                  className="p-6 rounded-lg transition-all hover:shadow-lg"
                  style={{ backgroundColor: '#f8f6f3', border: '1px solid rgba(0,0,0,0.05)' }}
                  data-testid={`testimonial-${index}`}
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div 
                      className="w-10 h-10 rounded-full flex items-center justify-center text-sm font-medium"
                      style={{ backgroundColor: '#1a1a1a', color: '#ffffff' }}
                    >
                      {testimonial.name.charAt(0)}
                    </div>
                    <div>
                      <p className="text-sm font-medium" style={{ color: '#1a1a1a' }}>{testimonial.name}</p>
                      <p className="text-xs" style={{ color: '#999' }}>{testimonial.timeAgo}</p>
                    </div>
                  </div>
                  <h3 
                    className="text-base font-medium mb-2"
                    style={{ color: '#8b7355', fontFamily: "'Playfair Display', serif" }}
                  >
                    {testimonial.title}
                  </h3>
                  <p className="text-sm font-light leading-relaxed" style={{ color: '#666' }}>
                    {testimonial.text}
                  </p>
                  <div className="flex items-center gap-4 mt-4 pt-4" style={{ borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                    <span className="text-xs" style={{ color: '#999' }}>❤️ {testimonial.engagement.likes}</span>
                    <span className="text-xs" style={{ color: '#999' }}>💬 {testimonial.engagement.comments}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Who is Farzeen Section */}
      <section className="py-16 md:py-24" style={{ backgroundColor: '#1a1a1a' }}>
        <div className="container mx-auto px-6 md:px-8">
          <div className="max-w-5xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              {/* Image */}
              <div className="relative order-2 md:order-1">
                <div 
                  className="relative overflow-hidden rounded-lg shadow-2xl"
                  style={{ border: '1px solid rgba(139, 115, 85, 0.3)' }}
                >
                  <img 
                    src={farzeenImage} 
                    alt="Farzeen" 
                    className="w-full h-auto object-cover"
                    data-testid="farzeen-photo"
                  />
                  <div 
                    className="absolute inset-0"
                    style={{ 
                      background: 'linear-gradient(to top, rgba(26,26,26,0.3) 0%, transparent 30%)'
                    }}
                  />
                </div>
              </div>
              
              {/* Content */}
              <div className="order-1 md:order-2">
                <p 
                  className="text-xs tracking-[0.3em] mb-4 font-light uppercase"
                  style={{ color: '#8b7355' }}
                >
                  My Story
                </p>
                <h2 
                  className="text-2xl md:text-3xl font-light mb-6"
                  style={{ fontFamily: "'Playfair Display', serif", color: '#ffffff' }}
                >
                  I'm no one
                  <span className="italic" style={{ color: '#8b7355' }}> special...</span>
                </h2>
                <div className="space-y-4">
                  <p className="text-sm md:text-base font-light leading-relaxed" style={{ color: 'rgba(255,255,255,0.85)' }}>
                    Just a single mom of 3 with lawyer bills and the solo provider.
                  </p>
                  <p className="text-sm md:text-base font-light leading-relaxed" style={{ color: 'rgba(255,255,255,0.7)' }}>
                    I couldn't wait for others to take responsibilities. I was tired of the burnout.
                  </p>
                  <p className="text-sm md:text-base font-light leading-relaxed" style={{ color: 'rgba(255,255,255,0.85)' }}>
                    So I learned to <span className="italic" style={{ color: '#8b7355' }}>earn from home</span> and build an extra income stream — just like many others now earning 
                    <span className="font-medium" style={{ color: '#8b7355' }}> $10K-$15K from home</span> straight from their phones.
                  </p>
                  <div className="pt-4 mt-4" style={{ borderTop: '1px solid rgba(139, 115, 85, 0.2)' }}>
                    <p className="text-sm font-light italic" style={{ color: 'rgba(255,255,255,0.5)' }}>
                      If I can do it as a single mom of 3, you can too.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What You'll Learn Section */}
      <section className="py-12 md:py-16" style={{ backgroundColor: '#f8f6f3' }}>
        <div className="container mx-auto px-6 md:px-8">
          <div className="max-w-3xl mx-auto">
            <h2 
              className="text-2xl md:text-3xl font-light text-center mb-10"
              style={{ fontFamily: "'Playfair Display', serif", color: '#1a1a1a' }}
            >
              In this training, you'll
              <span className="italic" style={{ color: '#8b7355' }}> discover:</span>
            </h2>
            
            <div className="space-y-4">
              {learnPoints.map((item, index) => (
                <div 
                  key={index} 
                  className="flex items-start gap-4 p-4 rounded-lg transition-all"
                  style={{ backgroundColor: '#ffffff' }}
                >
                  <div 
                    className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: '#8b7355' }}
                  >
                    <Check size={14} style={{ color: '#ffffff' }} />
                  </div>
                  <p className="text-sm md:text-base font-light" style={{ color: '#1a1a1a' }}>{item}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* The 3 Key Steps Section */}
      <section className="py-12 md:py-20" style={{ backgroundColor: '#1a1a1a' }}>
        <div className="container mx-auto px-6 md:px-8">
          <div className="max-w-5xl mx-auto">
            <p 
              className="text-xs tracking-[0.3em] mb-4 font-light text-center uppercase"
              style={{ color: '#8b7355' }}
            >
              The Method
            </p>
            <h2 
              className="text-2xl md:text-3xl font-light text-center mb-4"
              style={{ fontFamily: "'Playfair Display', serif", color: '#ffffff' }}
            >
              These 3 KEY Steps to building a
              <br />
              <span className="italic" style={{ color: '#8b7355' }}>THRIVING digital marketing business</span>
            </h2>
            <p 
              className="text-base font-light text-center mb-12"
              style={{ color: 'rgba(255,255,255,0.6)' }}
            >
              Without creating your own products...
            </p>
            
            <div className="grid md:grid-cols-3 gap-8">
              {keySteps.map((step, index) => (
                <div 
                  key={index}
                  className="p-8 rounded-lg text-center transition-all hover:scale-[1.02]"
                  style={{ backgroundColor: 'rgba(255,255,255,0.03)', border: '1px solid rgba(139, 115, 85, 0.2)' }}
                  data-testid={`step-${index + 1}`}
                >
                  <div 
                    className="text-3xl font-light mb-4"
                    style={{ color: '#8b7355', fontFamily: "'Playfair Display', serif" }}
                  >
                    {step.number}
                  </div>
                  <h3 
                    className="text-lg font-light mb-2"
                    style={{ color: '#ffffff', fontFamily: "'Playfair Display', serif" }}
                  >
                    {step.title}
                  </h3>
                  <p 
                    className="text-xs tracking-[0.2em] uppercase mb-4"
                    style={{ color: '#8b7355' }}
                  >
                    {step.subtitle}
                  </p>
                  <p className="text-sm font-light leading-relaxed" style={{ color: 'rgba(255,255,255,0.7)' }}>
                    {step.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Expectations Section */}
      <section className="py-12 md:py-16" style={{ backgroundColor: '#ffffff' }}>
        <div className="container mx-auto px-6 md:px-8">
          <div className="max-w-2xl mx-auto text-center">
            <h2 
              className="text-xl md:text-2xl font-light mb-6"
              style={{ fontFamily: "'Playfair Display', serif", color: '#1a1a1a' }}
            >
              To Set Proper
              <span className="italic" style={{ color: '#8b7355' }}> Expectations...</span>
            </h2>
            <p className="text-sm font-light leading-relaxed mb-4" style={{ color: '#666' }}>
              This is <span className="font-medium" style={{ color: '#1a1a1a' }}>NOT</span> a get rich quick scheme.
            </p>
            <p className="text-sm font-light leading-relaxed mb-4" style={{ color: '#666' }}>
              These results are from real students that have stayed consistent, taken massive action, and really worked hard for their results.
            </p>
            <p className="text-sm font-light leading-relaxed" style={{ color: '#666' }}>
              What I can say is this is truly what I believe is the <span className="italic" style={{ color: '#8b7355' }}>simplest business</span> to get started with.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 md:py-20" style={{ backgroundColor: '#1a1a1a' }}>
        <div className="container mx-auto px-6 md:px-8">
          <div className="max-w-2xl mx-auto text-center">
            <p 
              className="text-xs tracking-[0.3em] mb-4 font-light uppercase"
              style={{ color: '#8b7355' }}
            >
              Next Step
            </p>
            <h2 
              className="text-2xl md:text-3xl font-light mb-6"
              style={{ fontFamily: "'Playfair Display', serif", color: '#ffffff' }}
            >
              Ready to start your
              <span className="italic" style={{ color: '#8b7355' }}> freedom journey?</span>
            </h2>
            <p 
              className="text-base font-light mb-8"
              style={{ color: 'rgba(255,255,255,0.7)' }}
            >
              Join Digital Wealth Academy and get instant access to everything you need to build your online income.
            </p>
            
            <a 
              href="https://stan.store/FarzeenDigitalWealth/p/road-to-10k-monthly-as-a-stay-at-home-mom-"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 text-sm tracking-[0.15em] px-10 py-4 transition-all duration-300 hover:opacity-90"
              style={{ backgroundColor: '#8b7355', color: '#ffffff' }}
              data-testid="cta-button"
            >
              GET STARTED NOW
              <ArrowRight size={18} strokeWidth={1.5} />
            </a>
            
            <p className="mt-8 text-xs font-light" style={{ color: 'rgba(255,255,255,0.4)' }}>
              Questions? DM me{' '}
              <a 
                href="https://instagram.com/itsfarzeenkhan" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="underline transition-opacity hover:opacity-70"
                style={{ color: '#8b7355' }}
              >
                @itsfarzeenkhan
              </a>
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-6" style={{ backgroundColor: '#0a0a0a' }}>
        <div className="container mx-auto px-8 text-center">
          <p className="text-xs font-light" style={{ color: 'rgba(255,255,255,0.3)' }}>
            © {new Date().getFullYear()} Farzeen Digital Wealth. All rights reserved.
          </p>
        </div>
      </footer>

      <FloatingChatButton />
    </div>
  );
};

export default FunnelPage;
